import * as z from "zod/v4";
import { TeamCalendarEntryAgendaItemType } from "../agenda-item-type";
import { defineAgendaItemSchema } from "../base";

/**
 * A promotion attached to a calendar entry. Currently a free-form text
 * block describing the promotion — surfaced as LLM context during the
 * entry's active window. An entry can have multiple promotions.
 */
export const promotionAgendaItemSchema = defineAgendaItemSchema(
  TeamCalendarEntryAgendaItemType.Promotion,
  { details: z.string().nullish() },
);

export type PromotionAgendaItem = z.infer<typeof promotionAgendaItemSchema>;
